// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import Text from "components/typography/Text";

// #####################################################

const ShowMoreButtonStyled = styled.button`
	padding: 0.5rem 1rem 0;
	font-size: 0.8rem;
`;

// #####################################################

const ShowMoreButton = ({ onClick, children }) => {
	// #####################################################

	return (
		<ShowMoreButtonStyled onClick={onClick}>
			<Text color="primary">{children}</Text>
		</ShowMoreButtonStyled>
	);
};

// #####################################################

export default ShowMoreButton;

// #####################################################
